/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import { withRouter } from 'react-router';
import { isNaN } from 'lodash';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import ProcedurResultForm from './ProcedureResultForm';
import { getProcedureResultDetails, getProcedureType } from '../store/actions';
import * as CustomErrorMessage from './error_message';
import {
  checkValidDate,
  compareToFutureDate,
  compareTwoDatesGreaterThanOrEqual,
} from '../../../../SharedModules/DateUtilities/DateUtilities';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import { dateFormat } from '../../../../SharedModules/CommonConstants/commonConstants';
import { isReadOnly as isRead } from '../../../../SharedModules/utilities/utilities';
import { handleScrollToEvent } from '../../../../SharedModules/CommonUtilities/commonUtilities';

function ProcedureResult({ location, history }) {
  const loginState = useSelector(
    (state) => state?.sharedState?.SharedReducer?.loginStateStoreObj
  );
  let isReadOnly = false;
  if (loginState) {
    isReadOnly = isRead(location.pathname, loginState)?.readOnly || false;
  }
  const spinnerLoader = useSelector((state) => {
    return state?.sharedState.showPreLoader?.showPreLoader;
  });
  const [errorMessage, setErrorMessage] = useState([]);
  const [canProceedToSerachResultPage, setCanProceedToSerachResultPage] =
    useState(true);
  const dispatch = useDispatch();
  const searchProcedurResultDetail = (value) =>
    dispatch(getProcedureResultDetails(value));
  const getProcedureTypeDropDown = () => dispatch(getProcedureType());
  const [searchCriteria, setSearchCriteria] = useState({});
  const [redirect, setRedirect] = useState(false);
  const procedureReuslt = useSelector((state) => {
    if (
      state &&
      state.sharedState &&
      state.sharedState.ProcedureResultReducer &&
      state.sharedState.ProcedureResultReducer.rebateSystemSerchResult
    ) {
      return state.sharedState.ProcedureResultReducer.rebateSystemSerchResult;
    }
    return [];
  });
  const msg = useSelector(
    (state) => state.sharedState.ProcedureResultReducer.msg
  );
  const ProcedureTypeDropDown = useSelector((state) => {
    return state.sharedState.ProcedureResultReducer.procedureTypeDropDown;
  });
  const UserDefaultValues = useSelector(
    (state) => state.sharedState.UserDefaultReducer.UserDefaultsValues.data
  );

  const [fieldLevelError, setFieldLevelError] = useState({
    startDate: '',
    endDate: '',
  });
  const initializeValue = {
    dateRangeOptionRadio: 'All',
    dateRangeOptionStartDate: null,
    dateRangeOptionEndDate: null,
    procedurTypeRadio: 'All',
    procedurTypeSelectedOption: 'All',
    submitedBy: 'DRAMS,RAMS',
  };

  const getFilterValue = () => {
    const item = location.value;
    if (item && item.filterData) {
      return item.filterData;
    }
    return initializeValue;
  };

  const [values, setValue] = useState(getFilterValue());
  React.useEffect(() => {
    handleScrollToEvent();
  }, []);
  const onChangeValues = (e, property, value) => {
    if (property === 'dateRangeOptionRadio') {
      const userEnteredValue = e.target.value;
      setFieldLevelError({ ...fieldLevelError, startDate: '', endDate: '' });
      setErrorMessage([]);
      setCanProceedToSerachResultPage(true);
      setValue({
        ...values,
        [property]: userEnteredValue,
        dateRangeOptionStartDate: null,
        dateRangeOptionEndDate: null,
      });
    } else if (e) {
      const userEnteredValue = e.target.value;
      setValue({ ...values, [property]: userEnteredValue });
    } else {
      setValue({ ...values, [property]: value });
    }
  };

  const dateValideation = (date, event, field) => {
    let startDateError = '';
    let startDateInvalid = false;
    let endDateError = '';
    let isErrored = false;
    const errorMsgs = [];
    const startDate = document.getElementById('begindate-picker-dialog');
    const endDate = document.getElementById('endDate-picker-dialog');
    let startDateValueLength = 0;
    let endDateValueLength = 0;
    if (startDate?.value) {
      startDateValueLength = startDate.value.length;
    } else if (values.dateRangeOptionRadio === 'selectedDateRange') {
      isErrored = true;
      startDateError = CustomErrorMessage.START_DATE_REQUIRED;
      errorMsgs.push(CustomErrorMessage.START_DATE_REQUIRED);
    }
    if (endDate?.value) {
      endDateValueLength = endDate.value.length;
    }
    if (values.dateRangeOptionRadio === 'selectedDateRange') {
      if (field === 'startDt') {
        if (
          event === 'onBlur' &&
          date.target.value &&
          date.target.value.length > 5
        ) {
          const dateValue = date.target.value.split('/');
          if (dateValue[2].split('_').length === 3) {
            values.dateRangeOptionStartDate = moment(
              date.target.value,
              'MM/DD/YY'
            ).format(dateFormat);
          } else {
            values.dateRangeOptionStartDate =
              date.target.value && date.target.value !== ''
                ? date.target.value
                : null;
          }
        } else {
          values.dateRangeOptionStartDate =
            event === 'onBlur' ? date.target.value : date;
        }
      }
      if (field === 'endDt') {
        if (
          event === 'onBlur' &&
          date.target.value &&
          date.target.value.length > 5
        ) {
          const dateValue = date.target.value.split('/');
          if (dateValue[2].split('_').length === 3) {
            values.dateRangeOptionEndDate = moment(
              date.target.value,
              'MM/DD/YY'
            ).format(dateFormat);
          } else {
            values.dateRangeOptionEndDate =
              date.target.value && date.target.value !== ''
                ? date.target.value
                : null;
          }
        } else {
          values.dateRangeOptionEndDate =
            event === 'onBlur' ? date.target.value : date;
        }
      }
      if (
        values.dateRangeOptionStartDate === 'Invalid date' &&
        startDateValueLength > 0
      ) {
        startDateInvalid = true;
        isErrored = true;
        errorMsgs.push(CustomErrorMessage.INVALID_DATE);
        startDateError = CustomErrorMessage.INVALID_DATE;
      }
      if (
        values.dateRangeOptionEndDate === 'Invalid date' &&
        endDateValueLength > 0
      ) {
        isErrored = true;
        if (!startDateInvalid) {
          errorMsgs.push(CustomErrorMessage.INVALID_DATE);
        }
        endDateError = CustomErrorMessage.INVALID_DATE;
      }
      if (
        !startDateError &&
        values.dateRangeOptionStartDate &&
        !checkValidDate(values.dateRangeOptionStartDate)
      ) {
        isErrored = true;
        errorMsgs.push(CustomErrorMessage.INVALID_DATE);
        startDateError = CustomErrorMessage.INVALID_DATE;
      }
      if (
        !endDateError &&
        values.dateRangeOptionEndDate &&
        !checkValidDate(values.dateRangeOptionEndDate)
      ) {
        isErrored = true;
        errorMsgs.push(CustomErrorMessage.INVALID_DATE);
        endDateError = CustomErrorMessage.INVALID_DATE;
      }
      if (
        !startDateError &&
        !endDateError &&
        values.dateRangeOptionEndDate &&
        endDateValueLength > 0 &&
        values.dateRangeOptionStartDate &&
        compareTwoDatesGreaterThanOrEqual(
          values.dateRangeOptionEndDate,
          values.dateRangeOptionStartDate
        )
      ) {
        isErrored = true;
        errorMsgs.push(CustomErrorMessage.START_DATE_GRETERTHAN_END_DATE);
        endDateError = CustomErrorMessage.START_DATE_GRETERTHAN_END_DATE;
      }
      if (
        !startDateError &&
        values.dateRangeOptionStartDate &&
        compareToFutureDate(new Date(), values.dateRangeOptionStartDate)
      ) {
        isErrored = true;
        errorMsgs.push(CustomErrorMessage.START_DATE_FUTURE_DATE);
        startDateError = CustomErrorMessage.START_DATE_FUTURE_DATE;
      }

      setFieldLevelError({
        ...fieldLevelError,
        endDate: endDateError,
        startDate: startDateError,
      });
      if (errorMsgs.length > 0) {
        setErrorMessage(errorMsgs);
        return isErrored;
      }
      setErrorMessage([]);
    }
    return isErrored;
  };

  const validDate = (d, value, specialCase) => {
    let isValidDate = false;
    if (d === null && specialCase === 'EnteringValue') {
      return true;
    }
    if (specialCase && !value) {
      return false;
    }
    if (Object.prototype.toString.call(d) === '[object Date]') {
      isValidDate = true;

      if (isNaN(d)) {
        isValidDate = false;
      } else {
        isValidDate = true;
      }
    } else {
      isValidDate = false;
    }

    return isValidDate;
  };

  const handleChangeDate = (date, property) => {
    const regex = /[0-9]/g;
    let startDateFromDatePicker = null;
    let startDateFromPickerLength = 0;
    let endDateFromDatePicker = null;
    let endDateFromDatePickerLenght = 0;
    let startDateError = '';
    let startDateErrorMsg = true;
    let errormessageArray = [];
    const startDate = document.getElementById('begindate-picker-dialog');
    const endDate = document.getElementById('endDate-picker-dialog');
    if (property === 'dateRangeOptionStartDate' && date) {
      if (!endDate) {
        errorMessage.push(fieldLevelError.endDate);
      }
      startDateFromDatePicker = moment(date).format('MM/DD/YYYY');
      const startDateArrayFromDatePicker = startDateFromDatePicker.match(regex);
      if (startDateArrayFromDatePicker && startDateArrayFromDatePicker.length) {
        startDateFromPickerLength = startDateArrayFromDatePicker.length;
      }
    }
    if (property === 'dateRangeOptionEndDate' && date) {
      if (!startDate) {
        errorMessage.push(fieldLevelError.startDate);
      }
      endDateFromDatePicker = moment(date).format('MM/DD/YYYY');
      const endDateArrayFromDatePicker = endDateFromDatePicker.match(regex);
      if (endDateArrayFromDatePicker && endDateArrayFromDatePicker.length) {
        endDateFromDatePickerLenght = endDateArrayFromDatePicker.length;
      }
    }
    let startDateValueLength = 0;
    let endDateValueLength = 0;
    if (startDate && startDate.value) {
      const startDateArray = startDate.value.match(regex);
      if (startDateArray && startDateArray.length) {
        startDateValueLength = startDateArray.length;
      }
    }
    if (endDate) {
      const endDateArray = endDate.value.match(regex);
      if (endDateArray && endDateArray.length && endDateArray.length > 0) {
        endDateValueLength = endDateArray.length;
      }
    }

    if (
      property === 'dateRangeOptionStartDate' ||
      property === 'dateRangeOptionEndDate'
    ) {
      if (
        startDateValueLength < 8 &&
        fieldLevelError.startDate === CustomErrorMessage.START_DATE_FUTURE_DATE
      ) {
        startDateError = '';
      }
      if (
        (startDateValueLength === 8 || startDateFromPickerLength === 8) &&
        property === 'dateRangeOptionStartDate' &&
        validDate(
          new Date(values.dateRangeOptionEndDate),
          values.dateRangeOptionEndDate,
          'SpecialCase'
        ) &&
        validDate(date) &&
        compareTwoDatesGreaterThanOrEqual(
          date,
          values.dateRangeOptionEndDate
        ) &&
        !compareTwoDatesGreaterThanOrEqual(new Date(), date)
      ) {
        startDateError = '';
        errormessageArray = [];
        startDateErrorMsg = true;
      }
      if (
        (endDateValueLength === 8 || endDateFromDatePickerLenght === 8) &&
        property === 'dateRangeOptionEndDate' &&
        validDate(
          new Date(values.dateRangeOptionStartDate),
          values.dateRangeOptionStartDate,
          'SpecialCase'
        ) &&
        validDate(date) &&
        compareTwoDatesGreaterThanOrEqual(
          values.dateRangeOptionStartDate,
          date
        ) &&
        !compareTwoDatesGreaterThanOrEqual(
          new Date(),
          values.dateRangeOptionStartDate
        )
      ) {
        startDateError = '';

        errormessageArray = [];
        startDateErrorMsg = true;
      }
    }
    setErrorMessage(errormessageArray);
    setValue({
      ...values,
      [property]: moment(date).format('MM/DD/YYYY'),
    });

    startDateErrorMsg = !(startDateError.length > 0);
    setCanProceedToSerachResultPage(startDateErrorMsg);
  };

  useEffect(() => {
    setRedirect(false);
    if (!ProcedureTypeDropDown?.length) getProcedureTypeDropDown();
  }, []);
  useEffect(() => {
    if (procedureReuslt && procedureReuslt.length > 0 && redirect) {
      procedureReuslt.forEach((item, i) => {
        item.id = i;
        item.processDt = moment(new Date(item.processDt)).format('MM/DD/YYYY');
      });
      const updateTabs =
        JSON.parse(localStorage.getItem('tabItemsData')) === null
          ? []
          : JSON.parse(localStorage.getItem('tabItemsData'));
      updateTabs.push({
        navTo: '/ProcedureResultDetails',
        value: 'Procedure Results Detail',
      });
      localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));
      history.push({
        pathname: '/ProcedureResultDetails',
        procedureReuslt: procedureReuslt,
        searchCriteria: searchCriteria,
        isReadOnly: isReadOnly,
      });
    }
  }, [procedureReuslt, msg]);

  useEffect(() => {
    if (procedureReuslt && procedureReuslt.length === 0 && redirect) {
      const noRecordFound = [CustomErrorMessage.NO_RESULT_FOUND_ERROR];
      setErrorMessage(noRecordFound);
    }
  }, [procedureReuslt]);

  const searchProcedureResult = () => {
    let startDate = values.dateRangeOptionStartDate;
    let endDate = values.dateRangeOptionEndDate;
    if (
      values.procedurTypeRadio === 'SelcectedDateRange' &&
      values.procedurTypeSelectedOption === 'All'
    ) {
      setErrorMessage((arr) => [
        ...arr,
        CustomErrorMessage.PROCEDURE_TYPE_ERROR,
      ]);
      return;
    }
    if (canProceedToSerachResultPage && !dateValideation()) {
      const dateRangeOptionStartDate = values.dateRangeOptionStartDate
        ? moment(new Date(values.dateRangeOptionStartDate)).format('MM/DD/YYYY')
        : null;
      const dateRangeOptionEndDate = values.dateRangeOptionEndDate
        ? moment(new Date(values.dateRangeOptionEndDate)).format('MM/DD/YYYY')
        : null;

      const submittedBy =
        values.submitedBy === 'DRAMS,RAMS'
          ? ['DRAMS', UserDefaultValues.userId]
          : ['ALL'];

      const procedurTypeSelectedOption =
        values.procedurTypeRadio === 'All'
          ? 'All'
          : values.procedurTypeSelectedOption;
      const searchData =
        (dateRangeOptionStartDate &&
          dateRangeOptionStartDate !== 'Invalid date') ||
        (dateRangeOptionEndDate && dateRangeOptionEndDate !== 'Invalid date')
          ? {
              submittedBy: submittedBy,
              procedureType: procedurTypeSelectedOption,
              dateRangeVO: {
                startDate:
                  dateRangeOptionStartDate === 'Invalid date'
                    ? null
                    : dateRangeOptionStartDate,
                endDate:
                  dateRangeOptionEndDate === 'Invalid date'
                    ? null
                    : dateRangeOptionEndDate,
              },
            }
          : {
              submittedBy: submittedBy,
              procedureType: procedurTypeSelectedOption,
              dateRangeVO: {
                all: 'ALL',
              },
            };
      searchProcedurResultDetail(searchData);
      setSearchCriteria(searchData);
      setRedirect(true);
      setErrorMessage([]);
    }
    const startDateFiled = document.getElementById('begindate-picker-dialog');
    const endDateFiled = document.getElementById('endDate-picker-dialog');
    let startDateValueLength = 0;
    let endDateValueLength = 0;
    if (startDateFiled) {
      startDateValueLength =
        startDateFiled && startDateFiled.value && startDateFiled.value.length
          ? startDateFiled.value.length
          : 0;
    }
    if (endDateFiled) {
      endDateValueLength =
        endDateFiled && endDateFiled.value && endDateFiled.value.length
          ? endDateFiled.value.length
          : 0;
    }
    if (startDate === 'Invalid date' && startDateValueLength === 0) {
      startDate = null;
    }
    if (endDate === 'Invalid date' && endDateValueLength === 0) {
      endDate = null;
    }
    setValue({
      ...values,
      dateRangeOptionStartDate: startDate,
      dateRangeOptionEndDate: endDate,
    });
    cacheValue();
  };

  const cacheValue = () => {
    const data = JSON.parse(localStorage.getItem('tabItemsData'));
    if (data && Array.isArray(data) && data.length > 0) {
      const newTabData = data.map((x) => {
        if (x.value === 'Procedure Results') {
          x.filterData = values;
        }
        return x;
      });
      localStorage.setItem('tabItemsData', JSON.stringify(newTabData));
    }
  };

  return (
    <>
      <div className="tabs-container tBillPanel custom-check">
        <CustomSeparator parent1="System" parent2="Procedure Results" />
        {errorMessage === '' ? null : (
          <DisplayErrorMessages errorMessages={errorMessage} />
        )}
        <ProcedurResultForm
          spinner={spinnerLoader}
          values={values}
          onChangeValues={onChangeValues}
          handleChangeDate={handleChangeDate}
          searchProcedureResult={searchProcedureResult}
          ProcedureTypeDropDown={ProcedureTypeDropDown}
          fieldLevelError={fieldLevelError}
          dateValideation={dateValideation}
        />
      </div>
    </>
  );
}

export default withRouter(ProcedureResult);
